import * as React from "react";
import { Modal, TitleBar, useAppBridge } from "@shopify/app-bridge-react";
import { Box } from "@shopify/polaris";

let nextModalId = 0;

export default function UnsavedChangesDialog({
  open,
  onStay,
  onLeave,
  title = "Save changes?",
  message = "You have unsaved changes. Changes will be lost if you leave without saving.",
  stayLabel = "Stay",
  leaveLabel = "Leave without saving",
}) {
  const shopify = useAppBridge();
  const [modalId] = React.useState(() => `unsaved-changes-${nextModalId++}`);
  const wasOpen = React.useRef(false);

  React.useEffect(() => {
    if (open && !wasOpen.current) {
      shopify.modal.show(modalId);
    }
    wasOpen.current = open;
  }, [open, modalId, shopify]);

  const handleHide = React.useCallback(() => {
    onStay();
  }, [onStay]);

  const handleStay = React.useCallback(() => {
    shopify.modal.hide(modalId);
    onStay();
  }, [modalId, shopify, onStay]);

  const handleLeave = React.useCallback(() => {
    shopify.modal.hide(modalId);
    onLeave();
  }, [modalId, shopify, onLeave]);

  return (
    <Modal id={modalId} onHide={handleHide} variant="base">
      <TitleBar title={title}>
        <button onClick={handleStay} variant="primary">{stayLabel}</button>
        <button onClick={handleLeave}>{leaveLabel}</button>
      </TitleBar>
      <Box padding={400}>{message}</Box>
    </Modal>
  );
}
